import CowmedChip from '#/components/Chip'
import { OutdatedData } from '#/components/OutdatedData'
import { outdatedRules, verifyIfOutdated } from '#/components/OutdatedData/rules'
import Colors from '#/styles/Colors'

export const THI_OPTIONS = {
  comfort: {
    min: 0,
    status: 'comfort',
    style: Colors.thi.thermal_comfort,
  },
  mild_to_moderate_stress: {
    min: 72,
    status: 'mild_to_moderate_stress',
    style: Colors.thi.mild_to_moderate_stress,
  },
  moderate_to_severe_stress: {
    min: 80,
    status: 'moderate_to_severe_stress',
    style: Colors.thi.moderate_to_severe_stress,
  },
  severe_stress: {
    min: 90,
    status: 'severe_stress',
    style: Colors.thi.severe_stress,
  },
  stress_zone: {
    min: 68,
    status: 'stress_zone',
    style: Colors.thi.stress_zone,
  },
}

export const getThi = (thi: number) =>
  Object.values(THI_OPTIONS)
    .sort((a, b) => b.min - a.min)
    .find(option => thi >= option.min) ?? THI_OPTIONS.comfort

const TypeThi = ({ timestamp, value }: any) => {
  if (!value) return '-'

  const outdatedRule = verifyIfOutdated({ rules: outdatedRules.monitoring, timestamp })

  const formattedValue = <OutdatedData timestamp={timestamp}>{value}</OutdatedData>

  if (outdatedRule?.hideValue) return formattedValue

  return <CowmedChip value={formattedValue as any} style={getThi(value).style} width={70} />
}

export default TypeThi
